import { TextButton2 } from "common/components";
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  IconWrapper,
} from "common/components/icon";
import { Direction } from "common/enum/direction";
import { formatDateTime } from "common/utils/dateUtil";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

export const NavigatorArrowButton = ({ direction, disabled, onClick }) => {
  return (
    <IconWrapper
      style={{
        justifySelf: direction === Direction.LEFT ? "flex-start" : "flex-end",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.3 : 1,
      }}>
      {direction === Direction.LEFT ? (
        <ArrowLeftIcon onClick={disabled ? undefined : onClick} />
      ) : (
        <ArrowRightIcon onClick={disabled ? undefined : onClick} />
      )}
    </IconWrapper>
  );
};

export const DateNavigator = ({
  date,
  format,
  onClick,
  onPrev,
  onNext,
  disablePrev,
  disableNext,
  style,
}) => {
  const { t } = useTranslation();
  return (
    <DateNavigatorWrapper style={style}>
      <NavigatorArrowButton
        direction={Direction.LEFT}
        disabled={disablePrev}
        onClick={onPrev}
      />
      <TextButton2 style={{ flex: 1, textAlign: "center" }} onClick={onClick}>
        {formatDateTime(date, format, t)}
      </TextButton2>
      <NavigatorArrowButton
        direction={Direction.RIGHT}
        disabled={disableNext}
        onClick={onNext}
      />
    </DateNavigatorWrapper>
  );
};

const DateNavigatorWrapper = styled.div`
  display: flex;
  padding: 0.75rem;
  width: 15rem;
  align-items: center;
  background-color: var(--LightGray);
  border-radius: 0.5rem;
  gap: 0.5rem;
  box-sizing: border-box;
`;
